import { Star, CheckCircle2 } from "lucide-react";
import { VETERAN_IMG, BUSINESS } from "@/data/site";
import { useReveal } from "@/hooks/useReveal";

const POINTS = [
  "Built on honor, driven by integrity",
  "Respect your home, exceed expectations",
  "Reliable service & quality workmanship",
  "Community focused, quality delivered",
];

export const Veteran = () => {
  const [ref, visible] = useReveal();
  return (
    <section id="about" data-testid="about-section" className="relative bg-black py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} relative`}>
            <div className="relative border border-zinc-800 overflow-hidden">
              <img
                src={VETERAN_IMG}
                alt="Veteran owned and operated"
                className="w-full h-[420px] md:h-[520px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            </div>
            <div className="absolute -bottom-5 -left-2 md:left-8 bg-red-600 px-6 py-4">
              <span className="block font-heading text-3xl md:text-4xl tracking-wide text-white leading-none">
                U.S. Veteran
              </span>
              <span className="block text-[11px] font-bold tracking-[0.25em] uppercase text-white/90 mt-1">
                Owned & Operated
              </span>
            </div>
          </div>

          <div>
            <div className="flex items-center gap-3">
              <span className="h-px w-10 bg-red-600" />
              <span className="text-xs font-bold tracking-[0.3em] uppercase text-red-500">
                Why Precision
              </span>
            </div>
            <h2 className="mt-4 font-heading uppercase tracking-tight text-5xl md:text-6xl text-white leading-[0.95]">
              Backed By Service.<br />
              <span className="text-red-600">Built On Trust.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-zinc-400 leading-relaxed">
              {BUSINESS.name} is a veteran owned and operated business serving{" "}
              {BUSINESS.serviceArea}. We bring the same discipline, precision, and
              accountability from service to every home we work on — treating your
              property like it's our own.
            </p>

            <ul className="mt-8 space-y-4">
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <CheckCircle2 className="h-5 w-5 text-red-500 shrink-0 mt-0.5" />
                  <span className="text-zinc-200 font-medium">{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-9 inline-flex items-center gap-2 border border-zinc-800 bg-zinc-900/60 px-5 py-3">
              <Star className="h-4 w-4 text-red-500" fill="currentColor" />
              <span className="text-sm font-bold uppercase tracking-widest text-zinc-100">
                Faith. Family. Service. Integrity.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
